  // Initialize Bundle Cart on page load
  updateBundleCart();

  let addBundleButton = document.querySelectorAll('.quick-add__submit');
  addBundleButton.forEach((e) => {
    e.addEventListener('click', (event) => {
      preventDrawerActive();
      // Update Bundle Cart, wait until cart is updated
      setTimeout(() => {
        updateBundleCart();
      }, 1000);
    });
  });

  let viewCartButton = document.querySelector('.view-cart');
  viewCartButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector('cart-drawer').open(this);
  });

  async function updateBundleCart(handle) {
    // console.log('updateBundleCart');
    let collectionHandle = document.querySelector('.bundle-builder').getAttribute('data-collection-handle');
    let bundleCart = document.querySelector('.bundle-cart');
    await getSection('collections', collectionHandle, 'bundle-cart').then((data) => {
      bundleCart.innerHTML = data;
    });
    openBundleCart();
    removeButtons();
    watchCartDrawer();
  }

  function openBundleCart() {
    let openBundleCart = document.querySelector('.open-bundle-cart');
    if(openBundleCart.closest('.bundle-details').classList.contains('open')) {
      document.querySelector('#open-bundle-cart').checked = true;
    }
    openBundleCart.addEventListener('click', () => {
      openBundleCart.closest('.bundle-details').classList.toggle('open');
    });
  }

  function removeButtons() {
    let removeBundleItemButtons = document.querySelectorAll('.remove-item');
    removeBundleItemButtons.forEach((e) => {
      e.addEventListener('click', (event) => {
        event.preventDefault();
        let key = e.getAttribute('data-key');
        e.classList.add('loading');
        let cartDrawer = document.querySelector('cart-drawer-items');
        cartDrawer.updateQuantity({
          [key]: 0
        });
        setTimeout(() => {
          updateBundleCart();
        }, 1000);
      });
    });
  }

  function watchCartDrawer() {
    let cartDrawerItems = document.querySelector('cart-drawer-items');
    cartDrawerItems.addEventListener('click', () => {
      // console.log('cartDrawerItems clicked');
      setTimeout(() => {
        updateBundleCart();
      }, 1000);
    });
  }

   // Helper Function - Get a section to render through API
   async function getSection(category, handle, section) {
    return fetch('/' + category + '/' + handle + '?section_id=' + section)
      .then((response) => response.text())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function preventDrawerActive() {
    // Check every 200ms if the cart drawer is active, if so, close it
    document.querySelector('cart-drawer').classList.add('hidden');
    setTimeout(() => {
      if (document.querySelector('cart-drawer').classList.contains('active')) {
        document.querySelector('body').classList.remove('overflow-hidden');
        document.querySelector('cart-drawer').classList.remove('active');
        document.querySelector('cart-drawer').classList.remove('hidden');
        return true;
      } else {
        preventDrawerActive();
      }
    }, 200);
  }

  // Show corresponding bundle-products based on which data-bundle-step is clicked and update the current step
  let bundleSteps = document.querySelectorAll('.step-navigation .step');
  let bundleProducts = document.querySelectorAll('.bundle-products');
  let currentStep = document.querySelector('.step-navigation .current-step');

  bundleSteps.forEach(function (step) {
    step.addEventListener('click', function () {
      let stepNumber = this.getAttribute('data-bundle-step');
      let stepTitle = this.getAttribute('data-step-title');
      bundleSteps.forEach(function (step) {
        step.classList.remove('active');
      });
      this.classList.add('active');
      bundleProducts.forEach(function (product) {
        product.classList.add('hidden');
      });
      document.querySelector('.step-' + stepNumber).classList.remove('hidden');
      currentStep.innerHTML = stepTitle;
      checkPagination();
    });
  });

  let paginateNextStep = document.querySelector('.bundle-pagination .step-next');
  let paginatePreviousStep = document.querySelector('.bundle-pagination .step-previous');
  paginateNextStep.addEventListener('click', function () {
    let currentStep = document.querySelector('.steps .step.active');
    currentStep.nextElementSibling.click();
    checkPagination();
    document.querySelector('.bundle-builder').scrollIntoView({ behavior: 'smooth' });
  });
  paginatePreviousStep.addEventListener('click', function () {
    let currentStep = document.querySelector('.steps .step.active');
    currentStep.previousElementSibling.click();
    checkPagination();
    document.querySelector('.bundle-builder').scrollIntoView({ behavior: 'smooth' });
  });

  function checkPagination() {
    // Check if first step is active, if so, hide previous button
    if (bundleSteps[0].classList.contains('active')) {
      paginatePreviousStep.classList.add('hidden');
    } else {
      paginatePreviousStep.classList.remove('hidden');
    }
    // Check if last step is active, if so, hide next button
    if (bundleSteps[bundleSteps.length - 1].classList.contains('active')) {
      paginateNextStep.classList.add('hidden');
    } else {
      paginateNextStep.classList.remove('hidden');
    }
  }